import { mapApi } from '_utils'
import Equipment from '_entities/equipment'
import config from '_config'
import axios from 'axios'

const screenshotURL = config.screenshotURL
let intranet = 0
const {
  getEquipmentsByIds,
  getScreenShot,
  getSendOrder,
  getEquipmentById,
} = mapApi([
  'getEquipmentsByIds',
  'getScreenShot',
  'getSendOrder',
  'getEquipmentById',
])
export default {
  namespaced: true,
  state: {
    equipment: {},
    curPlayDevice: {
      id: '',
      streamUrl: '',
      type: 0,
      intranet: 0,
      cameraName: '',
    },
    equipments: [],
    equipmentsByPage: [],
    curPageIndex: 0, // 列表模式 页索引
    curIndex: 0, // 大图模式 索引
    checkedEq: [], // 列表模式 选中的数据
    first: true, // true:进入巡课界面  false:在巡课界面
    mode: 0, // 模式 0：列表模式  1：大图模式
    curDeviceMicrophone: '', // 当前设备麦克风
    curCallingMicrophone: '', // 当前喊话麦克风
    watermarkGlobalSetting: {
      text: '',
      username: '',
      phone: '',
      ip: '',
      color: '',
      backgroundText: '',
    },
  },
  getters: {},
  mutations: {
    // fix
    handleEquipment(state, data) {
      state.first = true
      state.equipment = new Equipment(data[0])
    },

    setCurPageIndex(state, index) {
      console.log('setCurPageIndex ')
      state.curPageIndex = index
    },

    setCurIndex(state, index) {
      console.log('setCurIndex ')
      state.curIndex = index
    },

    setCheckedEq(state, ids) {
      console.log('setCheckedEq ')
      state.checkedEq = state.equipments.filter(e => ids.includes(e.id))
    },

    toggleModeList(state) {
      console.log('toggleModeList ')
      state.mode = 0
      state.checkedEq = []
    },
    toggleModeScreen(state) {
      state.mode = 1
    },
    setFirst(state) {
      state.first = false
    },
    updateCover(state, start) {
      state.equipments.slice(start, start + 8).forEach(e => {
        e.cover = `${screenshotURL}/${e._key}.jpg?_t=${+new Date()}`
      })
    },
    // fix
    setStream(state, { id, streamUrl, intranet }) {
      if (state.equipment.id === id) {
        state.equipment.streamUrl = streamUrl
        state.equipment.intranet = intranet
      }
    },
    // fix
    delStream(state, targetEq) {
      if (state.equipment.id === targetEq.id) {
        state.equipment.streamUrl = ''
      }
    },
    // fix
    initScreenStream(state) {
      state.curPlayDevice.id = state.equipment.id
      state.curPlayDevice.streamUrl = state.equipment.streamUrl
      state.curPlayDevice.intranet = state.equipment.intranet
      state.curPlayDevice.type = 0
    },
    setCurPlayDevice(state, tarCurPlayDevice) {
      state.curPlayDevice.id = tarCurPlayDevice.id
      state.curPlayDevice.streamUrl = tarCurPlayDevice.streamUrl
      state.curPlayDevice.intranet = tarCurPlayDevice.intranet
      state.curPlayDevice.type = tarCurPlayDevice.type
      state.curPlayDevice.cameraName = tarCurPlayDevice.cameraName
    },
    setCurDeviceMicrophone(state, deviceMicrophone) {
      state.curDeviceMicrophone = deviceMicrophone
    },
    setCurCallingMicrophone(state, callingMicrophone) {
      state.curCallingMicrophone = callingMicrophone
    },
    setCurPlayDeviceStreamUrl(state, streamUrl) {
      state.curPlayDevice.streamUrl = streamUrl
    },
    setWatermarkGlobalSetting(state, watermarkSetting) {
      state.watermarkGlobalSetting.text = watermarkSetting.text
      state.watermarkGlobalSetting.username = watermarkSetting.username
      state.watermarkGlobalSetting.phone = watermarkSetting.phone
      state.watermarkGlobalSetting.ip = watermarkSetting.ip
      state.watermarkGlobalSetting.color = watermarkSetting.color
      state.watermarkGlobalSetting.backgroundText =
        state.watermarkGlobalSetting.phone +
        ' ' +
        state.watermarkGlobalSetting.username +
        ' ' +
        state.watermarkGlobalSetting.ip
    },
  },
  actions: {
    // fix
    async setEquipmentById({ commit, state }, id) {
      // 把单个 id 转成接口需要的格式（逗号分隔字符串）
      const eqIds = String(id)
      // 如果你后面可能会支持批量，再改成 [id] -> ['1','2'] -> '1,2'
      // const eqIds = [id].join(',')

      // 调用接口
      const data = await getEquipmentsByIds({ eqIds })
      // 提交单项处理的 mutation，假设你把它改成 handleEquipment
      commit('handleEquipment', data)
      // console.log('ssssssssssssssssssssssssssssssss', state.equipment)
      return data
    },

    async fetchScreenshotByIds({ commit, state }) {
      console.log('fetchScreenshotByIds ')
      const start = state.curPageIndex * 8
      const ids = state.equipments.slice(start, start + 8).map(e => e.id)
      getScreenShot({ ids }).then(res => {})
      //  update cover after 2 seconds
      setTimeout(() => {
        commit('updateCover', start)
      }, 2000)
    },

    async fetchStream({ commit, state }, eq) {
      const id = eq.id
      console.log('接口方法' + eq.localIp + 'id:' + eq.id)
      if (eq.localIp != null && eq.dnsApi != null) {
        console.log('进入!') // 推流方法
        axios.defaults.baseURL = eq.dnsApi
        await axios({
          url: '',
          params: {},
          timeout: 1500,
        }).then(
          response => {
            console.log('连接成功!')
            intranet = 1
            return true
          },
          error => {
            console.log('错误', error.message)
            intranet = 0
            return false
          }
        )
      }
      console.log(intranet)
      // console.log('🚀 ~ fetchStream ~ intranet:', intranet)
      // 根据 id 获取设备的集控版本 version
      const { version } = await getEquipmentById({ id })
      const streamUrl = await getSendOrder({ //eslint-disable-line
        eqIds: [eq.id],
        orderCode: 'startPush',
        isIntranet: intranet,
        localIp: eq.localIp,
        version,
      })
      commit('setStream', { id, streamUrl, intranet })
      intranet = 0
    },
    // fix
    async delEqStream({ commit }, eq) {
      commit('delStream', eq)
    },
  },
}
